import * as api from '../api'
import request from '../request'


// const getTeacherList = data => {
//   return request({
//     url : api.teacherList,
//     params : data
//   })
// }

const selectRegisterUserList = data => {
  return request({
    url : api.selectRegisterUserList,
    method : 'POST',
    data
  })
}

//updateRegisterUserInfo
const updateRegisterUserInfo = data => {
  return request({
    url : api.updateRegisterUserInfo,
    method : 'POST',
    data
  })
}

//deleteRegisterUserInfo
const deleteRegisterUserInfo = data => {
  return request({
    url : api.deleteRegisterUserInfo,
    method : 'get',
    params : data

  })
}

const checkPhoto = data => {
  return request({
    url : api.checkPhoto,
    method : 'POST',
    isUpload:true,
    data
  })
}

const savePhoto = data => {
  return request({
    url : api.savePhoto,
    method : 'POST',
    isUpload:true,
    data
  })
}
const standardPhotoByPreview = data => {
  return request({
    url : api.standardPhotoByPreview,
    method : 'POST',
    isUpload:true,
    data
  })
}
const deleteDish = data => {
  return request({
    url: api.deleteDish,
    data
  })
}
const getSelectPlan = data => {
  return request({
    url : api.getSelectPlan,
    method : 'POST',
    data
  })
}

const getSelectList = data => {
  return request({
    url : api.selectList,
    method : 'POST',
    data
  })
}

const queryAllSubject = data => {
  return request({
    url : api.queryAllSubject,
    method : 'POST',
    data
  })
}

const getPlanCourse = data => {
  return request({
    url : api.getPlanCourse,
    method : 'POST',
    data
  })
}

const del= data => {
  return request({
    url : api.del,
    method : 'get',
    params : data
  })
}

const registerUser = data => {
  return request({
    url : api.registerUser,
    method : 'POST',
    data
  })
}

const addStudent = data => {
  return request({
    url : api.addStudent,
    method : 'POST',
    data
  })
}

const planStudentImport = data => {
  return request({
    url : api.planStudentImport,
    method : 'POST',
    isUpload:true,
    data
  })
}

const studentExport = data => {
  return request({
    url : api.studentExport,
    method : 'POST',
    data
  })
}

const selectOneSignUp = data => {
  return request({
    url : api.selectOneSignUp,
    method : 'get',
    params : data
  })
}

const UpdateRegistration = data => {
  return request({
    url : api.UpdateRegistration,
    method : 'POST',
    data
  })
}

const batchImportUserPhoto = data => {
  return request({
    url : api.batchImportUserPhoto,
    method : 'POST',
    isUpload:true,
    data
  })
}

const getCurrentPlan = data => {
  return request({
    url : api.getCurrentPlan,
    method : 'POST',
    data
  })
}

const registerAgain = data => {
  return request({
    url : api.registerAgain,
    method : 'POST',
    data
  })
}

const getBillManageList = data => {
  return request({
    url : api.getBillList,
    method : 'POST',
    data
  })
}

const getBillManageTotal = data => {
  return request({
    url : api.getBillTotal,
    method : 'POST',
    data
  })
}

const refundBill = data => {
  return request({
    url: api.refundBill,
    data
  })
}

const rePayBill = data => {
  return request({
    url: api.rePayBill,
    data
  })
}

const exportBillList = data => {
  return request({
    url : api.exportBillList,
    method : 'POST',
    data
  })
}

const getInvoiceList = data => {
  return request({
    url : api.invoiceList,
    method : 'POST',
    data
  })
}

const downloadInvoice = data => {
  return request({
    url : api.invoiceDownload,
    method : 'POST',
    data
  })
}

const batchDownloadInvoice = data => {
  return request({
    url : api.invoiceBatchDownload,
    method : 'POST',
    data
  })
}

const exportInvoiceList = data => {
  return request({
    url : api.invoiceExport,
    method : 'POST',
    data
  })
}

export default {
    checkPhoto,
    savePhoto,
    getSelectPlan,
    getSelectList,
    queryAllSubject,
    getPlanCourse,
    del,
    registerUser,
    addStudent,
    planStudentImport,
    studentExport,
    selectRegisterUserList,
    selectOneSignUp,
    UpdateRegistration,
    deleteRegisterUserInfo,
    updateRegisterUserInfo,
    batchImportUserPhoto,
    registerAgain,
    getCurrentPlan,
    getBillManageList,
    getBillManageTotal,
    exportBillList,
    getInvoiceList,
    downloadInvoice,
    batchDownloadInvoice,
    exportInvoiceList,
    deleteDish,
    refundBill,
    rePayBill,
    standardPhotoByPreview
}
